import { useEffect, useState } from "react";

import { getFingerprintAsync, initializePC } from "@Components/ZeroFraud/zero-fraud";

export interface Fingerprint {
    fingerprint: string;
    persistentCookie: string;
}

const useDeviceFingerprint = () => {
    const [fingerprint, setFingerprint] = useState<string>("");

    useEffect(() => {
        initializePC();
        getFingerprintAsync()
            .then((r) => {
                const fingerprintString = JSON.stringify(r);
                setFingerprint(btoa(fingerprintString));
            })
            .catch((r) => console.error(r));
    }, []);

    return fingerprint;
};

export default useDeviceFingerprint;
